function MonitoringPage() {
    return (
        <div>
            Monitoring page
        </div>
    )
}

export default MonitoringPage;
